// Shared validation + persistence for the "remembered" child panel id between
// page loads. Centralised so AppConnectGuard and PanelSwitcher use the same
// rules (positive integer, exists in the merchant's panel list, otherwise
// silently dropped so we never call switchPanel(NaN) or with a stranger's id).

export const STORED_PANEL_KEY = 'selectedPanelId'

export function readStoredPanelId(): number | null {
  const raw = localStorage.getItem(STORED_PANEL_KEY)
  if (!raw) return null
  const parsed = parseInt(raw, 10)
  if (!Number.isInteger(parsed) || parsed <= 0) {
    localStorage.removeItem(STORED_PANEL_KEY)
    return null
  }
  return parsed
}

export function writeStoredPanelId(panelId: number): void {
  if (!Number.isInteger(panelId) || panelId <= 0) return
  localStorage.setItem(STORED_PANEL_KEY, String(panelId))
}

export function clearStoredPanelId(): void {
  localStorage.removeItem(STORED_PANEL_KEY)
}

export function isPanelIdInList(
  panelId: number,
  panelIds: ReadonlyArray<number | null | undefined>,
): boolean {
  return panelIds.some((id) => id === panelId)
}
